var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"statusCircle",style:({'background-color': _vm.getColor, height: `${_vm.radius}px`,  width: `${_vm.radius}px`})}),_c('div',{staticClass:"caption pl-1"},[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }